import { render, staticRenderFns } from "./_form.submission-contents.page.vue?vue&type=template&id=3f5af784&scoped=true&"
import script from "./_form.submission-contents.page.vue?vue&type=script&lang=js&"
export * from "./_form.submission-contents.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.submission-contents.page.vue?vue&type=style&index=0&id=3f5af784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5af784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
